<template>
  	<div class="dashboardbar" v-if="isActive">
		<div v-if="isDisplayCoordinate" class="CoordinateDisplay">
			<div class="slot">Lon: {{ radianToAngleStr(monitorData.mouseCoord.longitude)|fixedFloat(5) }}</div>
			<div class="slot">Lat: {{ radianToAngleStr(monitorData.mouseCoord.latitude)|fixedFloat(5) }}</div>
			<div class="slot">H: {{ monitorData.mouseCoord.height|fixedFloat(2) }}m</div>
		</div>
		<div v-if="isDisplayTime" class="clockDisplay">
			<div class="slot timebotton" v-on:click="switchTime()">
				<div class="time" title="Switch">Time</div>:
			</div>
			{{currentTime}}
		</div>
		<div v-if="isDisplayFrameRate" class="FrameRateDisplay">FPS:{{monitorData.frameFps}}</div>
  	</div>
</template>

<script>
/* eslint-disable */
	
export default {
	name: 'DashboardBar',
	data () {
		return {
			msg: 'This is Dashboard tool bar!',
			isActive: true,
			isDisplayCoordinate: true,
			isDisplayFrameRate: true,
			isDisplayTime: false,
			currentTime: "",
			cesiumClock: pfAirViewer.clock.currentTime,
			monitorData: {
				frameFps: "",
				mouseCoord: {
					longitude: 1,
					latitude: 1,
					height: 1
				}
			},
			coordinate: {
			lon: "-1.8402538",
			lat: "-0.4820130",
			h: "-4269.87"
			},
			fpsValue: "60"
		}
	},
	watch: {
        monitorData : {
            handler:function(val,oldval){
				//this.currentTime = Cesium.JulianDate.toDate(val);
				//this.updateTime();
			},
			deep: true
		}
    },
    mounted: function() {
    	pfAirViewer.createMonitoring({
			feedbackData: this.monitorData
		});
		//this.cesiumClock = pfAirViewer.clock.currentTime;
		var that = this;
        // that.updateTime();
        this.currentTime = "Time waring!";
        setInterval(function(){
			that.updateTime();
        },1000);
		//setInterval('this.updateTime()', 3000);
    },
    methods: {
		updateTime:function() {
			//this.currentTime = Cesium.JulianDate.toDate(pfAirViewer.clock.currentTime).toString();
			this.currentTime = Cesium.JulianDate.toDate(pfAirViewer.clock.currentTime).toLocaleString();
		},
		updateCurrentTime: function(){
			pfAirViewer.clock.currentTime = Cesium.JulianDate.now();
            pfAirViewer.clock.clockRange = Cesium.ClockRange.UNBOUNDED;
		},
		switchTime: function(){
			pfAirViewer.clock.shouldAnimate  = !pfAirViewer.clock.shouldAnimate;
		},
		radianToAngleStr: function(value) {
			return Cesium.Math.toDegrees(value);
		}
    },
    components: {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dashboardbar{ 
    background: rgba(48, 51, 54, 0.8) none repeat scroll 0 0; 
    position:fixed; 
	bottom:.5em;
	padding: 3px;
    z-index:1; 
    left:35%; 
    width:30%; 
    min-width:420px; 
    text-align:center; 
    line-height:2.5em; 
	color:#fff;
	border-radius: 5px;
}
.dashboardbar a{ 
    color:#fff;
}
.CoordinateDisplay{
  	float:left; padding:1px 15px;
}
.clockDisplay {
  	float:left; padding:1px 10px 0px 10px;
}
.FrameRateDisplay{
  	float:right; padding:1px 10px;
}
.slot {
	float:left; padding:0px 8px 0px 0px;
}
.timebotton {
	margin: 0px 0px 0px 0px;
}
.time {
	float:left;
	cursor: pointer;
	padding-right: 2px;
	padding-top: 0px;
	padding-bottom: 0px;
}
.time:hover{
	float:left;
	background-color:black;
	padding-left: 4px;
	padding-right: 4px;
	border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/DashboardBar.vue